module.exports = __webpack_public_path__ + "static/media/idle0.1dde5e57.svg";